import { LayoutGenerator } from "dependencies/emptyLayout/utils/layoutGenerator"
import { Button } from "materials/button/menus/model"
import { Image } from "materials/image/menus/model"
import { Tabs } from "materials/tabs/menus/model"
import { navMenuVertical } from "materials/navMenuVertical/menus/model"
import showNav from "assets/images/showNav.png"
import layoutImg from "assets/images/leftMenu/layout/layout_1.png"

/**
 * 门户登陆默认配置数据
 */
export const home = [
  {
    styleName: "自由布局",
    thumbnail: layoutImg,
    pluginName: ["appNavPlugin"],
    titleOptions: [
      {
        type: "top",
        elementOptions: [
          {
            innerElement: "cxTabs",
            isActive: false,
            isShow: false,
            type: "classification",
            elementInLayoutId: 0,
            options: new Tabs({})
          },
          {
            innerElement: "imageComponent",
            isShow: false,
            type: "classification",
            elementInLayoutId: 1,
            options: new Image({})
          }
        ]
      },
      {
        type: "bottom",
        elementOptions: []
      },
      {
        type: "left",
        elementOptions: []
      },
      {
        type: "right",
        elementOptions: []
      }
    ],
    rows: new LayoutGenerator({
      // row的数量需与tab的数量同步
      rows: [
        {
          height: "100%",
          cols: [
            {
              width: "100%",
              elementOptions: [
                new Button({
                  pluginMark: "navButton",
                  elementInLayoutId: 0,
                  top: 0,
                  left: 15,
                  width: 24,
                  height: 24,
                  // iconSrc: showNav,
                  iconSrc: "340f1e9f08721111ed0b1a47d14b67f06212",
                  iconType: "icon",
                  iconMargin: 0,
                  background: [{ type: "color", label: "颜色", isThemeColor: false, color: "rgba(0,0,0, 0)" }],
                  content: "",
                  borderColor: "rgba(0,0,0,0)",
                  hoverBorderColor: "rgba(0,0,0,0)"
                }),
                new navMenuVertical({
                  pluginMark: "nav",
                  elementInLayoutId: 1,
                  resizable: false,
                  draggable: false,
                  top: 24,
                  left: 0,
                  width: 414,
                  height: 36
                  // background:[{"type":"color","label":"颜色","isThemeColor":false,"color":"rgba(255, 255, 255, 1)"}]
                })
              ]
            }
          ]
        }
      ]
    }).rows
  }
]
/**
 * 大屏文本默认配置数据
 */
export const bs = []
